
export class InsertPhResponse {

    insertStatusCode: number;
    insertMessage: string;

    constructor() {}
}
